import React, {Component} from 'react';
import './BackToTop.css';
import { goToAnchor } from 'react-scrollable-anchor';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faArrowUp from '@fortawesome/fontawesome-free-solid/faAngleUp';
import classnames from 'classnames';

class BackToTop extends Component {
  constructor() {
    super();
    this.state = {
      onTop: true,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, false);
  }

  handleScroll = () => {
    // Navbar is 60px in height. Could also get height of DOM node here using
    // findDOMNode(this.refs.navRef) and subtract that.

    // var heightToShow = window.innerHeight - 100;
    const threshold = 100;

    if (window.pageYOffset > threshold) {
      this.setState({ onTop: false });
    }

    if (window.pageYOffset <= threshold) {
      this.setState({ onTop: true });
    }
  };
  backToTop = () => {
    goToAnchor('main');
  }

  render() {
    return <div 
    	className={classnames({"back-to-top": true, 'is-hidden': this.state.onTop})}
    	onClick={this.backToTop}
    	>
    	<FontAwesomeIcon icon={faArrowUp}/>
    </div>
  }
}

export default BackToTop;


// WEBPACK FOOTER //
// ./src/components/BackToTop.js